import React, { Component,useState} from "react";
import DOMPurify from 'dompurify';

const clickDelay = 1500;
let lastClick = 0;

export default class CaptchaDotNet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ready : false,
      string : '',
      imageString : '',
      audioLink : ''
    };
    this.isRequestingCaptcha = false;
    this.reloadCaptcha = this.reloadCaptcha.bind(this)
  }

  reloadCaptcha() {
    if (new Date().getTime() >= lastClick+clickDelay) {
      if (this.state.ready) {
        this.setState({
          ready : false,
        });
      }
      lastClick = new Date().getTime();
    }
  }

  render(props) {
    if (!this.state.ready && !this.isRequestingCaptcha) {
      this.loadCaptcha();
    }
    return (<div><div id='theCaptcha' dangerouslySetInnerHTML={{ __html: this.state.string+this.state.imageString+this.state.audioLink }}></div><div style={{'display':'flex','columnGap':'150px','marginTop':'1vh'}}><button id='btnReloadCaptcha' onClick={this.reloadCaptcha}>New Image</button></div></div>);
  }
  
  loadCaptcha() {
    this.isRequestingCaptcha = true;
    fetch('https://cwcreations.net/php/query_captcha.php')
         .then((res) => res.json())
         .then((data) => {
            this.isRequestingCaptcha = false;
            this.setState({ready : true, string : DOMPurify.sanitize(data.stringObject), imageString:DOMPurify.sanitize(data.imageObject),
                            audioLink : DOMPurify.sanitize(data.audioLink)
            })
         }); 
  }
}